(() => {
  const init = root => {
    if (!root || root.dataset.dvReady) return;
    root.dataset.dvReady = 'true';
    const slides = [...root.querySelectorAll('[data-dv-slide]')];
    const dots = [...root.querySelectorAll('[data-dv-show]')];
    let slide = 0;
    const show = i => {
      slide = (i + slides.length) % slides.length;
      slides.forEach((s, n) => { s.hidden = n !== slide; });
      dots.forEach((d, n) => d.setAttribute('aria-pressed', String(n === slide)));
    };
    const giftCards = [...root.querySelectorAll('[data-dv-gift-grid] [data-dv-card]')];
    const filters = root.querySelector('.dv-filters');
    const core = window.DVStorefront;
    const currency = root.dataset.currency;
    const rate = core?.rateFor(currency, root.dataset.baseCurrency, window.Shopify);
    const limits = core ? core.budgets(rate) : [5000, 10000, 20000];
    if (core && rate) {
      const amounts = limits.map(value => core.format(value, currency, true));
      const endAmount = value => value.replace(`${currency} `, '');
      filters.querySelector('[data-dv-filter="small"]').textContent = filters.dataset.underLabel.replace('[amount]', amounts[0]);
      filters.querySelector('[data-dv-filter="mid"]').textContent = `${amounts[0]}–${endAmount(amounts[1])}`;
      filters.querySelector('[data-dv-filter="high"]').textContent = `${amounts[1]}–${endAmount(amounts[2])}`;
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-dv-prev],[data-dv-next],[data-dv-show],[data-dv-filter],[data-dv-more]');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-dv-prev')) show(slide - 1);
      if (button.hasAttribute('data-dv-next')) show(slide + 1);
      if (button.hasAttribute('data-dv-show')) show(Number(button.dataset.dvShow) - 1);
      if (button.hasAttribute('data-dv-filter')) {
        event.preventDefault();
        const filter = button.dataset.dvFilter;
        let visible = 0;
        giftCards.forEach(card => {
          const price = Number(card.dataset.price);
          const include = filter === 'all' ? card.dataset.primary === 'true' : filter === 'mid' ? price >= limits[0] && price <= limits[1] : filter === 'high' ? price > limits[1] && price <= limits[2] : filter === 'small' ? price < limits[0] : filter === 'party' ? card.dataset.party === 'true' : filter === 'silver' ? card.dataset.silver === 'true' : false;
          card.hidden = !include;
          if (include) visible++;
        });
        root.querySelectorAll('.dv-filters [data-dv-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.dvFilter === filter)));
        root.querySelector('[data-dv-empty]').hidden = visible > 0;
        root.querySelector('[data-dv-gift-grid]').dataset.visible = visible;
        root.querySelector('[data-dv-filter-status]').textContent = filters.dataset.shownLabel.replace('[count]', visible);
        if (!button.closest('.dv-filters')) root.querySelector('#dv-gift-edit').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
      if (button.hasAttribute('data-dv-more')) {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        root.querySelectorAll('[data-dv-new-grid] [data-dv-card]').forEach((card, n) => { card.hidden = n >= 4 && !expanded; });
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
      }
    });
    root.querySelector('.dv-hero-slider').addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(slide - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(slide + 1); }
    });
  };
  document.querySelectorAll('[data-dv-christmas]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-dv-christmas]').forEach(init));
})();
